// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_84-3";
export var contentContainer = "_84-0";
export var editorContainer = "_84-1";
export var quillInputForm = "_84-2";
export var zoneDivider = "_84-4";